import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, admin = false, superAdmin = false, userRole = false }) => {
  const { user, loading , needsProfileCompletion } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (admin && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  if (superAdmin && user.role !== 'super') {
    return <Navigate to="/" replace />;
  }

  if (userRole && user.role !== 'user') {
    return <Navigate to="/" replace />;
  }

  if (needsProfileCompletion) {
    return <Navigate to="/complete-profile" replace />;
  }

  return children;
};

export default ProtectedRoute;